import React, { useState, useEffect } from "react";
import { XCircle } from "react-bootstrap-icons";
import Axios from "../config/AxiosConfig";

const Payment = () => {
  const [payments, setPayments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPayments();
  }, [page, searchQuery]);

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const response = await Axios.get("super-admin/payments/all", {
        params: { search: searchQuery, page, limit: 10 },
      });
      setPayments(response.data.data);
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Error fetching payments:", error);
      setPayments([]);
    }
    setLoading(false);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchQuery("");
  };

  return (
    <div className="payment-container">
      <h2>Payments List</h2>

      <div className="search-container">
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="Search by Restaurant Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <XCircle className="clear-icon" size={18} onClick={handleClearSearch} />
          )}
        </div>
        <button onClick={() => setSearchQuery(searchTerm)}>Search</button>
      </div>

      <table className="payment-table">
        <thead>
          <tr>
            <th>SNo</th>
            <th>Restaurant Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Amount</th>
            <th>Transaction ID</th>
            <th>Payment Date</th>
            <th>Expiry Date</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan="8">Loading payments...</td></tr>
          ) : payments.length > 0 ? (
            payments.map((payment, index) => (
              <tr key={payment._id}>
                <td>{index + 1 + (page - 1) * 10}</td>
                <td>{payment.restaurantData?.restaurantName || "N/A"}</td>
                <td>{payment.restaurantData?.email || "N/A"}</td>
                <td>{payment.restaurantData?.mobileNumber || "N/A"}</td>
                <td>{payment.amount}</td>
                <td>{payment.transactionId || "N/A"}</td>
                <td>{new Date(payment.paymentDate).toLocaleDateString()}</td>
                <td>{new Date(payment.expiryDate).toLocaleDateString()}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No payments found</td>
            </tr>
          )}
        </tbody>
      </table>

      {payments.length > 0 && (
        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>Previous</button>
          {[...Array(totalPages)].map((_, i) => (
            <button key={i} className={page === i + 1 ? "active" : ""} onClick={() => setPage(i + 1)}>
              {i + 1}
            </button>
          ))}
          <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </div>
  );
};

export default Payment;
